(function () {
  const money = (cents, currency) => {
    // basic formatting; Shopify will already show currency symbol in most stores
    const value = (cents / 100).toFixed(2);
    const symbol = currency === "AUD" ? "$" : currency === "NZD" ? "$" : "$";
    return `${symbol}${value}`;
  };

  const getThreshold = (el, currency) => {
    const aud = parseInt(el.dataset.aud || "0", 10);
    const nzd = parseInt(el.dataset.nzd || "0", 10);
    const def = parseInt(el.dataset.default || "0", 10);

    if (currency === "AUD") return aud || def;
    if (currency === "NZD") return nzd || def;
    return def;
  };

  const updateBars = async () => {
    const bars = document.querySelectorAll(".ei-shipbar");
    if (!bars.length) return;

    let cart;
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      cart = await res.json();
    } catch (e) {
      return;
    }

    bars.forEach((bar) => {
      const currency = cart.currency || "AUD";
      const threshold = getThreshold(bar, currency);
      const total = cart.total_price || 0;

      const msg = bar.querySelector(".ei-shipbar__msg");
      const fill = bar.querySelector(".ei-shipbar__fill");

      if (!threshold || !msg || !fill) return;

      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, Math.round((total / threshold) * 100));

      if (total >= threshold) {
        msg.textContent =
          currency === "AUD"
            ? "Complimentary AU shipping included."
            : "Complimentary shipping included.";
      } else {
        msg.textContent =
          currency === "AUD"
            ? `You’re ${money(remaining, currency)} away from complimentary AU shipping.`
            : `You’re ${money(remaining, currency)} away from complimentary shipping.`;
      }

      fill.style.width = `${progress}%`;
    });
  };

  // Run on load
  document.addEventListener("DOMContentLoaded", updateBars);

  // Catch common cart interactions (Impulse uses AJAX)
  document.addEventListener("click", (e) => {
    if (
      e.target.closest("button[name='plus']") ||
      e.target.closest("button[name='minus']") ||
      e.target.closest("[data-cart-remove]") ||
      e.target.closest("a[href*='cart/change']") ||
      e.target.closest("button[type='submit'][name='update']")
    ) {
      setTimeout(updateBars, 500);
    }
  });

  document.addEventListener("change", (e) => {
    if (e.target.matches("input[name='updates[]'], input.quantity__input")) {
      setTimeout(updateBars, 500);
    }
  });

  // Also run when Shopify sections re-render
  document.addEventListener("shopify:section:load", updateBars);
})();